import { Autocomplete, FormGroup, InputLabelProps, TextField, TextFieldProps } from '@mui/material'
import { SetStateAction, Dispatch, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

import { useOrganizations } from '../../index'

interface Suborg {
  orgId: string
  orgName: string
}

interface AssignSuborgFieldProps {
  disabled?: boolean
  value?: Suborg
  setSuborgId: Dispatch<SetStateAction<string | undefined>>
  suborgId?: string
  inputLabelProps?: InputLabelProps
  textFieldProps?: TextFieldProps
}

export const AssignSuborgField = ({
  disabled,
  value,
  setSuborgId,
  suborgId,
  textFieldProps,
}: AssignSuborgFieldProps) => {
  const { t } = useTranslation('@cibo/profile/components/AssignSuborgField')
  const org = useOrganizations()

  const orgs = useMemo(
    () => (org.data ? org.data.items.map(item => item.orgInfo) : []),
    [org.isFetching]
  )

  return (
    <FormGroup>
      {org.isFetching ? (
        <TextField
          disabled
          InputProps={{
            endAdornment: <ArrowDropDownIcon />,
          }}
          {...textFieldProps}
        />
      ) : (
        <Autocomplete<Suborg>
          isOptionEqualToValue={(option, value) => option.orgId === value?.orgId}
          id="org-select"
          disabled={disabled || org.isFetching || orgs.length === 0}
          options={orgs || ([] as Suborg[])}
          autoHighlight
          getOptionLabel={option => option.orgName}
          onChange={(e, v) => setSuborgId(v ? v.orgId : '')}
          loading={org.isLoading}
          value={orgs.find(org => org.orgId === suborgId)}
          renderInput={params => (
            <TextField
              {...params}
              placeholder={t('searchForOrg')}
              InputProps={{
                ...params.InputProps,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
              {...textFieldProps}
            />
          )}
        />
      )}
    </FormGroup>
  )
}
